import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, FileText, Image, Settings, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/basvurular", label: "Başvurular", icon: Inbox },
  { to: "/admin/icerik", label: "İçerik", icon: FileText },
  { to: "/admin/medya", label: "Medya", icon: Image },
  { to: "/admin/ayarlar", label: "Ayarlar", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/giris");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#EDEDEA] flex">
      <aside className="w-56 shrink-0 border-r border-[#1f1f1f] bg-[#0D0D0D] flex flex-col fixed inset-y-0 z-20">
        <div className="p-5 border-b border-[#1f1f1f]">
          <p className="font-blackletter text-2xl">CELLAT<span className="text-[#8B0000]">36</span></p>
          <p className="text-[10px] tracking-[0.3em] text-[#525252] uppercase mt-1">PR Paneli</p>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-3 text-sm transition-colors ${
                  isActive ? "bg-[#8B0000]/15 text-[#EDEDEA] border-r-2 border-[#C1121F]" : "text-[#A3A3A3] hover:text-[#EDEDEA] hover:bg-[#141414]"
                }`
              }
            >
              <Icon size={16} strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#1f1f1f] space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-2 py-2 text-sm text-[#A3A3A3] hover:text-[#EDEDEA]">
            <ExternalLink size={15} strokeWidth={1.5} /> Siteyi Gör
          </a>
          <button data-testid="admin-logout-btn" onClick={doLogout} className="flex items-center gap-3 px-2 py-2 text-sm text-[#A3A3A3] hover:text-[#C1121F] w-full">
            <LogOut size={15} strokeWidth={1.5} /> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-56 p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
